// HEADER = 'reservations_app_';
export default {
    // GLOBALS
    'date': 'Date',
    'time': 'Time',
    'party': 'Party Size',
    'title_preset1': 'Book A Table',
    'title_preset2': 'Reservations',
    'title_preset3': 'Table Reservation',
    'title_preset4': 'Booking Service',
    'title_preset5': 'Order Service',
    'button_preset1': 'Book A Table',
    'button_preset2': 'Reserve Now',
    'button_preset3': 'Reserve Table',
    'button_preset4': 'Book Now',
    'button_preset5': 'Submit',
    'party_size_option_single': '1 Person',
    'party_size_option_plural': '${params.count} People',
    'external_special_request': {external: 'openrest_cartview_kitchen_requests'},
    'external_freemium_info': {external: 'openrest_freemiumbarview_freemium_bar_info'},
    'preview_upgrade_button': {external: 'openrest_freemiumbarview_freemiumupgrade'},
    'modal_close': {external: 'openrest_itemview_close'},
    'error_empty': '${params.fieldType} is empty',
    'error_empty_select': '${params.fieldType} not selected',

    // SUCCESS POPUP
    'success_btn': 'GOT IT',
    'success_title': 'Thank You ${params.name}',
    'success_description_pending': 'We received your reservation and will email or text you to confirm.',
    'success_description_confirmed': 'Your reservation is confirmed. See you soon!',
    'success_id_label': 'Reservation Number',
    'success_date_label': {global: 'date'},
    'success_time_label': {global: 'time'},
    'success_party_label': {global: 'party'},
    'success_comment_label': {global: 'external_special_request'},
    'success_footer': 'Your reservation request confirmation was sent at ${params.time} to ${params.email}. Questions? Call us at ${params.phone}',
    'success_preview_header_text': 'You’ve just placed a reservation.',
    'success_preview_header_button': 'See Reservations',
    'success_preview_header_upgrade_button': {global: 'preview_upgrade_button'},
    'success_preview_header_helptip': {global: 'external_freemium_info'},

    // SMS VALIDATION
    'sms_validate_back': '(${back.begin}back to your reservation details${back.end})',
    'sms_validate_description': 'Confirm your phone number to complete your reservation',

    // ERROR RESPONSE
    'error_title': {external: 'openrest_checkoutordererror_title'},
    'error_description1': {external: 'openrest_checkoutordererror_bugdescription'},
    'error_description2': {external: 'openrest_checkoutordererror_bugdescription2'},
    'error_ok_button': 'BACK TO RESERVATION',
    'error_default_description1': 'We can’t take this reservation due to a last minute change.',
    'error_default_description2': 'Please try reserving again.',
    'error_default_ok': {external: 'openrest_checkoutordererror_defaultbutton'},

    // DETAILS FORM
    'form_title': 'Enter Your Information',
    'form_contact_details': 'Contact',
    'form_first_name': {external: 'openrest_checkoutcontactview_firstname'},
    'form_last_name': {external: 'openrest_checkoutcontactview_lastname'},
    'form_phone': {external: 'openrest_checkoutcontactview_phonenumber'},
    'form_email': {external: 'openrest_checkoutcontactview_emailaddress'},
    'form_table_info': 'Reservation details',
    'form_edit_details': {external: 'openrest_menubuilderdish_wix_edit_tooltip'},
    'form_special_requests': {global: 'external_special_request'},
    'form_request_disclaimer': 'Add your special request here. We’ll do our best to accommodate it.',
    'form_date': {global: 'date'},
    'form_time': {global: 'time'},
    'form_party': {global: 'party'},
    'form_default_button': {global: 'button_preset1'},
    'form_preview_header_text': 'You’re trying online reservations now.',
    'form_preview_header_upgrade_button': {global: 'preview_upgrade_button'},
    'form_preview_header_helptip': {global: 'external_freemium_info'},
    'form_error_phone': {external: 'openrest_checkoutcontactview_phonedigitserror'},
    'form_error_email': {external: 'openrest_checkoutcontactview_emailerror'},
    'form_error_empty': {global: 'error_empty'},
    // form date errors
    'form_error_date_past': 'Date and time entered are in the past. Please select a different reservation time',
    'form_error_date_early': 'We only accept reservations for ${params.time} ahead. For earlier reservations please call us at ${params.phone}',
    'form_error_date_late': 'We only accept reservations up until ${params.time} in the future. For later reservations please call us at ${params.phone}',
    'form_error_date_closed': 'We are no longer accepting online reservations. Please call us at ${params.phone} to make a reservation.',
    'form_error_date_bad': 'We don’t accept reservations for this time. We accept reservations for: ${params.hours}',
    'form_error_date_default': 'We don’t accept reservations for this time. ${params.comment}',

    // DISABLED RESERVATION POPUP
    'disabled_title': 'We don\'t accept online reservations yet.',
    'disabled_closed_title2': 'We\'re currently not accepting reservations online.',
    'disabled_description': 'Please call us to place your reservation.',
    'disabled_confirm': {external: 'openrest_settingsview_wix_ok'},
    'disabled_preview_header_text': 'Upgrade to start taking reservations on your site.',
    'disabled_preview_header_button': 'Try Reservations',
    'disabled_preview_header_upgrade_button': {global: 'preview_upgrade_button'},
    'disabled_preview_header_helptip': {global: 'external_freemium_info'},

    // WIDGET
    'app_date': {global: 'date'},
    'app_time': {global: 'time'},
    'app_party': {global: 'party'},
    'app_default_title': {global: 'title_preset1'},
    'app_default_button': {global: 'button_preset1'},
    'app_error_empty': {global: 'error_empty_select'}
};
